import React from 'react';
import classNames from 'classnames';
import styles from './card.module.scss';

interface ICard extends React.PropsWithChildren, React.HTMLAttributes<HTMLDivElement> {
    primary?: boolean;
    secondary?: boolean;
    noTitle?: boolean;
    isInsideFulltext?: boolean;
    ancestor?: boolean;
    className?: string;
}

const Card: React.FC<ICard> = ({
    primary,
    secondary,
    noTitle,
    isInsideFulltext,
    children,
    ancestor,
    className,
    ...props
}) => {
    return (
        <div
            className={classNames(
                {
                    [styles.serpCard]: true,
                    [styles.serpCardPrimary]: primary,
                    [styles.serpCardSecondary]: secondary,
                    '-no-title': noTitle,
                    '-inside-fulltext': isInsideFulltext,
                    '-has-ancestor': ancestor,
                } ,
                className
            )} data-testid="filter-card"
            {...props}
        >
            {children}
        </div>
    );
};

export default Card;
